import { createSelector } from 'reselect';

const selectWorkspaceRoot = (state) => state.workspace;

export const selectWorkspaceList = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.list
);

export const selectCurrentWorkspace = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.currentWorkspace
);

export const selectWorkspacePlan = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.plan
);

export const selectWorkspaceRestrictions = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.restrictions
);

export const selectWorkspaceTeams = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.teams
);

export const selectWorkspaceMembers = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.members
);

export const selectWorkspaceIsInitialized = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.isInitialized
);

export const selectWorkspaceIsLoading = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.isLoading
);

export const selectWorkspaceError = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.error
);

// --- Derived restriction selectors ---

export const selectCanCollaborate = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.canCollaborate ?? false
);

export const selectCanCreateTeams = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.canCreateTeams ?? false
);

export const selectCanInviteMembers = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.canInviteMembers ?? false
);

export const selectCanShareDiagrams = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.canShareDiagrams ?? false
);

export const selectMaxDiagrams = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.maxDiagrams ?? 3
);

export const selectMaxSeats = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.maxSeats ?? 1
);

export const selectMaxTeams = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.maxTeams ?? 0
);

// True when the user has reached the diagram limit for their plan.
// diagramCount must be passed as a second argument to the selector factory.
export const makeSelectIsDiagramLimitReached = () => createSelector(
    [selectMaxDiagrams, (_state, diagramCount) => diagramCount],
    (maxDiagrams, diagramCount) => {
        if (maxDiagrams === -1) return false;
        return diagramCount >= maxDiagrams;
    }
);
